const DynamicContentWrapper = document.getElementById('DynamicPagination');
const sectionId = DynamicContentWrapper.getAttribute('data-id');

let existingPath = DynamicContentWrapper.getAttribute('data-base-url');
let pageQueryParam = DynamicContentWrapper.getAttribute('data-current-page') !== '' ? `&page=${DynamicContentWrapper.getAttribute('data-current-page')}`: '';
console.log(`${existingPath}?${pageQueryParam}&section_id=${sectionId}`);


function filterArticles(appendResultsToEnd) {
    const url = `${existingPath}?${pageQueryParam}&section_id=${sectionId}`;
    if (!appendResultsToEnd) {
        document.getElementById('DynamicPagination').scrollIntoView();
        document.querySelector('.dynamic-pagination-wrap').classList.add('loading-filtered');
    }
    fetch(url)
    .then(response => response.text())
    .then((responseText) => {
        const html = responseText;
        let updatedPaginationHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('pagination-outer-wrap').innerHTML;
        let updatedArticlesHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ArticleGrid').innerHTML;
        if (appendResultsToEnd === true) {
            document.getElementById('ArticleGrid').innerHTML += updatedArticlesHtml;
            document.getElementById('pagination-outer-wrap').innerHTML = updatedPaginationHTML;
            setupViewMoreObserver();
        } else {
            document.getElementById('ArticleGrid').innerHTML = updatedArticlesHtml;
            document.getElementById('pagination-outer-wrap').innerHTML = updatedPaginationHTML;

            setTimeout(function (){
                document.querySelector('.dynamic-pagination-wrap').classList.remove('loading-filtered');
            }, 100);
        }
        // Animation code
        // ...
    });
}

document.querySelector('#DynamicPagination').addEventListener('click', function (e) {
    if(e.target && e.target.matches('.js-pagination-wrapper a')){
        e.preventDefault();
        pageQueryParam = parseInt(e.target.getAttribute('data-jump-to'), 10) == 1 ? '' : `page=${parseInt(e.target.getAttribute('data-jump-to'), 10)}`;
        filterArticles(true);
    }
});

function setupViewMoreObserver() {
    if (document.getElementById('pagination-outer-wrap') !== null) {
        function onVisible(element, callback) {
            new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        callback(element);
                        observer.disconnect();
                    }
                });
            }).observe(element);
        }

        onVisible(document.querySelector('#pagination-outer-wrap'), function () {
            document.querySelector('.pagination__load-more a').click();
        });
    };
}

setupViewMoreObserver();
